import dynamic from "next/dynamic";
import { Box } from "src/components/UI";
import SkeletonLoader from "src/components/UserInterface/Skeleton/SkeletonLoader";

export const PosLocator = dynamic(() => import("HCIDPosLocator/PosLocator"), {
  ssr: false,
  loading: () => (
    <Box flex={1} justifyContent="center" alignItems="center" height="100%">
      <SkeletonLoader isLoaded={false} width="100%" height="100vh">
        Loading...
      </SkeletonLoader>
    </Box>
  ),
});
